import { KeyRound } from "lucide-react";
import { ClientSegmentedControl } from "../ClientSegmentedControl";
import { ClientInstructions } from "../McpWizard/client-instructions";
import { mcpConfig } from "../../lib/mcp-config";
import { getMcpClient, type McpClientId } from "../../lib/mcp-clients";
import * as Analytics from "../../analytics";

// // // //

/**
 * McpSetupGuide
 * Static MCP setup instructions with a segmented control to switch between
 * supported clients. Values are placeholders (copy off) until the user
 * generates real credentials via "Connect now".
 */
export function McpSetupGuide(props: {
    selectedClient: McpClientId;
    onSelectClient: (client: McpClientId) => void;
}) {
    const { selectedClient, onSelectClient } = props;

    const isOauth = getMcpClient(selectedClient).auth === "oauth";

    const handleSelect = (client: McpClientId) => {
        Analytics.trackSelectClient({ location: "guide", client });
        onSelectClient(client);
    };

    return (
        <div className="w-full lg:sticky lg:top-6">
            <div className="rounded-xl border bg-card p-6 shadow-sm sm:p-8">
                <p className="text-xs font-semibold uppercase tracking-wide text-primary">
                    Quick setup
                </p>
                <h3 className="mt-2 text-pretty text-xl font-semibold tracking-tight">
                    Connect {mcpConfig.serverName} to your MCP Client
                </h3>

                <ClientSegmentedControl
                    value={selectedClient}
                    onValueChange={handleSelect}
                    className="mt-4"
                />

                <div className="mt-4">
                    <ClientInstructions
                        client={selectedClient}
                        enableCopy={false}
                    />
                </div>

                <div className="mt-6 flex items-start gap-3 rounded-md border bg-muted px-3 py-2.5">
                    <KeyRound
                        className="mt-0.5 size-4 shrink-0 text-muted-foreground"
                        aria-hidden="true"
                    />
                    <p className="text-xs leading-relaxed text-muted-foreground">
                        {isOauth
                            ? "The Client ID and Secret above are placeholders."
                            : "The API key above is a placeholder."}{" "}
                        Use{" "}
                        <span className="font-medium text-foreground">
                            Connect now
                        </span>{" "}
                        to generate your own, then paste it in.
                    </p>
                </div>
            </div>
        </div>
    );
}
